<template>
  <div id="results">
    <div class="info">
      <p class="bold">
        On average businesses in the
        <span class="industry">{{ selectedIndustry }}</span> industry have kept
        their employees:
      </p>
    </div>

    <ResultBar v-for="(res, i) in results" :key="i" :currentResult="res" />
  </div>
</template>

<script>
import ResultBar from "./ResultBar.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Results",
  components: {
    ResultBar
  },
  props: {
    msg: String,
    currentResult: {}
  },
  computed: {
    ...mapGetters({
      selectedIndustry: "getSelectedIndustry",
      results: "getResults"
    })
  },
  methods: {
    ...mapActions({
      getResults: "getResults"
    })
  },
  watch: {
    selectedIndustry(industry) {
      this.getResults(industry);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/colours";

#results {
  padding: 30px 160px 0 160px;
  margin-bottom: 50px;

  @media (max-width: 769px) {
    padding: 30px;
    margin-bottom: 350px;
  }

  .info {
    text-align: center;
    border-bottom: 2px solid $teal;
    margin-bottom: 15px;

    p {
      line-height: 24px;
      margin-top: 0;
      padding: 0;

      span.industry {
        text-transform: uppercase;
      }
    }
  }
}
</style>
